import { ProgressSpinner } from 'primereact/progressspinner';
import {
    Dropdown as PrimeReactDropdown,
    DropdownProps as PrimeReactDropdownProps,
} from 'primereact/dropdown';

import './style.css';
import renderIsRequired from '../utils/renderIsRequired';

interface IDropdown extends PrimeReactDropdownProps {
    label?: string;
    labelStyle?: React.CSSProperties;
    loading?: boolean;
    error?: string;
    required?: boolean;
    wrapperStyle?: React.CSSProperties;
}

export const Dropdown: React.FC<IDropdown> = ({
    label,
    name,
    labelStyle,
    loading = false,
    error,
    required,
    ...rest
}) => {
    return (
        <div className='custom-dropdown' style={rest.wrapperStyle}>
            <span>
                <label
                    htmlFor={name}
                    style={{
                        marginRight: '8px',
                        display: label ? 'inherit' : 'none',
                        ...labelStyle,
                    }}
                >
                    {label}
                    {renderIsRequired(required)}
                </label>
                <div className='wrap-content'>
                    <PrimeReactDropdown
                        className={
                            rest.className + (error ? '  p-invalid' : '')
                        }
                        disabled={loading || rest.disabled}
                        {...rest}
                    />
                    {loading && (
                        <ProgressSpinner
                            style={{
                                width: '20px',
                                height: '20px',
                                margin: '0 0',
                            }}
                            strokeWidth='6'
                            className='custom-spinner'
                        />
                    )}
                </div>
                {error && (
                    <small
                        id={`${name}-help`}
                        className='p-error block dropdown-error'
                    >
                        {error}
                    </small>
                )}
            </span>
        </div>
    );
};
